import { RouteType } from "../../../types/RouteType";
import { PdfEditorViewStore } from "./PdfEditorViewStore";

const PdfEditorRoute: RouteType = {
  name: "Pdf Editor",
  path: "/pdf/:documentId/:tab",
  defaultParams: { tab: "viewer" },
  defaultQueryParams: { pageNumber: "1" },
  layout: "/app",
  requiresAuth: true,
  // hidden: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      component: () => import("./components/PdfEditor.Header"),
      title: "PDF",
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./components/PdfEditor.Body"),
      grayBackground: true,
    },
  },

  beforeEnter: async ({ rootStore }) => {
    // Create the view store if it doesn't exist
    if (!(rootStore as any).pdfEditorViewStore) {
      (rootStore as any).pdfEditorViewStore = new PdfEditorViewStore(rootStore);
    }

    // The reaction in the view store will automatically load the document
    // when it detects the documentId from the route params
    return true;
  },

  onExit: ({ rootStore }) => {
    // Clean up the view store when leaving the route
    const pdfEditorViewStore = (rootStore as any).pdfEditorViewStore;
    if (pdfEditorViewStore) {
      pdfEditorViewStore.cleanup();
    }
  },

  dialogs: [
    {
      name: "annotationForm",
      component: () => import("../dialogs/AnnotationForm"),
      title: "Edit Annotation",
      onSubmit: async ({ rootStore }) => {
        const data = (rootStore as any).pdfEditorViewStore?.selectedAnnotation;
        if (data?.id) {
          await (rootStore as any).pdfAnnotationsStore.patch(data.id, data);
          (rootStore as any).routerStore?.closeDialog();
        }
      },
      onSubmitValidation: ({ rootStore }) => {
        const data = (rootStore as any).pdfEditorViewStore?.selectedAnnotation;
        return !!data?.id;
      },
      cancelButton: true,
    },
  ],
};

export default PdfEditorRoute;
